import Util from '@/lib/util'
export default [
    {
        title:Util.L('Client'),
        width:150,
        key:'clientName'
    }]